import { useEffect } from 'react';
import InteractionService from '../../../services/interaction_service';
import ActivityService from '../../../services/activity_service';
import ContactInteractionService from '../../../services/contactInteraction_service';

const Fetch = (vm) => {
  const fetchInteractions = async () => {
    vm.setLoading(true);
    try {
      const pageInteraction = await (
        vm.userFilter ? (async () => {
          const userActivityInteraction =
            (await ContactInteractionService.get({
              EmailContact: vm.userFilter.PrincipalEmail?.trim(),
              EmailAlternativeContact: vm.userFilter.AlternativeEmail?.trim(),
              IdentificationContact: vm.userFilter.NumeroIdentificacion?.trim(),
              amount: vm.amount,
            })) ?? [];
          if (vm.logout(userActivityInteraction)) return [];
          const interactionFilter = await Promise.all(
            userActivityInteraction.map(async (inter) => {
              const interaction = await InteractionService.get(inter.FK_Interaction);
              if (vm.logout(interaction)) return null;

              return {
                ...interaction,
                dateRegister: inter.CreateDate,
              };
            })
          );
          return interactionFilter.filter(Boolean);
        })() : (async () => {
          const allInteractions = await InteractionService.getAll();
          if (vm.logout(allInteractions)) return [];
          const initialEditedScores = allInteractions?.reduce((acc, inter) => {
            acc[inter?.Id] = Math.floor(inter?.Score);
            return acc;
          }, {});
          vm.setEditedScores(initialEditedScores || {});
          return allInteractions || [];
        })()
      );
      const pageInteractionFinal = await Promise.all(
        (pageInteraction || []).map(async (inter) => {
          const nameActivity = await ActivityService.get(inter.FK_Activity);
          if (vm.logout(nameActivity)) return null;

          return {
            ...inter,
            type: nameActivity?.Name,
          };
        })
      );
      vm.setInteractions((pageInteractionFinal || []).filter(Boolean));
    } catch (e) {
      vm.message(e?.message || e, "error");
    } finally {
      vm.setLoading(false);
    }
  };

  useEffect(() => {fetchInteractions()}, [vm.score]);

  return { fetchInteractions };
};

export default Fetch;
